import { render, staticRenderFns } from "./AreaEmbargadaSigaSemaMt.vue?vue&type=template&id=74c7abfd&lang=pug"
import script from "./AreaEmbargadaSigaSemaMt.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaSigaSemaMt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports